import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  filterPopperPaper: {
    width: 240,
    maxWidth: '100dvw',
  },
  filterPopperPaperTitle: {
    padding: theme.spacing(2, 2, 0),
  },
  filterPopperPaperContent: {
    padding: theme.spacing(2),
  },
  filterPopperPaperActions: {
    padding: theme.spacing(0, 2, 2),
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  filterPopperPaperContentList: {
    marginLeft: theme.spacing(-2),
    marginRight: theme.spacing(-2),
    width: 'auto !important',
  },
  filterPopperPaperContentListItemButton: {
    padding: theme.spacing(1, 2),
  },
}));

export default useStyles;
